import React from 'react'
import { Grid } from '@material-ui/core'
import { Button, RenderHTML } from '../../../../../../components'
import { getAddress, getDetail, getPhones, getStrategy, THEMES } from '../../../../../../utils'
import { get } from 'lodash'

/**
 * Contact Job Detail Component
 */
const JobDetail = (props) => {
  const { jobs, strategy, onEdit, onDelete, loading, editJob } = props

  return (
    <Grid item xs={9} container spacing={3}>
      <Grid item xs={12}>
        <div className='section_title'>Institution</div>
      </Grid>

      {(jobs || []).map((job, index) => {
        if (!job || !job._id) {
          return null
        }

        const address = getAddress(job)
        const phones = getPhones(job.phone, job.direct_telephone)
        const jobStrategy = (strategy || [])
          .find((strategy) => (strategy && strategy.factset_entity_id === job.factset_entity_id))

        return (
          <Grid item xs={12} container key={job._id}>
            <Grid item xs container className='contact-job_detail'>

              <Grid container item spacing={3}>
                <Grid item xs={4}>
                  <div className='section_subtitle'>Institution Name</div>
                  <div className='section_detail'>
                    {get(job, 'institution_name', '-')}
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className='section_subtitle'>Address</div>
                  <div className='section_detail'>{<RenderHTML html={address} />}</div>
                </Grid>
                <Grid item xs={4}>
                  <div className='section_subtitle'>Corporate Phone(s)</div>
                  <div className='section_detail'>{<RenderHTML html={getDetail(phones)} />}</div>
                </Grid>

                <Grid item xs={4}>
                  <div className='section_subtitle'>Job Title</div>
                  {(job.title && job.title.trim()) || '-'}
                </Grid>
                <Grid item xs={4}>
                  <div className='section_subtitle'>Function(s)</div>
                  <div className='section_detail section_detail--multiline'>
                    {(job.functions && Array.isArray(job.functions) && job.functions.length)
                      ? (job.functions).map((item, index) => (
                        <p key={index}>{item}</p>)
                      ) : '-'}
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className='section_subtitle'>Coverage/Strategy</div>
                  <div className='section_detail'>{getStrategy(jobStrategy)}</div>
                </Grid>
              </Grid>

              <div className='contact-job_detail-action'>
                <Button
                  loading={(job._id === editJob) && loading}
                  theme={THEMES.SOFT_GREY}
                  icon='q4i-edit-4pt'
                  square
                  onClick={() => onEdit({ value: job, strategy: jobStrategy, index })} />
                <Button
                  theme={THEMES.SOFT_GREY}
                  icon='q4i-trashbin-4pt'
                  square
                  onClick={() => onDelete({ value: job, strategy: jobStrategy, index })} />
              </div>

            </Grid>
          </Grid>
        )
      })}

      <Grid item xs={12}>
        <Button
          theme={THEMES.RAIN}
          label={`Add ${(jobs && Array.isArray(jobs) && jobs.length) ? 'Another' : ''} Institution`}
          onClick={() => onEdit()} />
      </Grid>
    </Grid>
  )
}

export default JobDetail
